import { Injectable, OnDestroy } from "@angular/core";
import { GridApi, GridOptions } from "@ag-grid-community/core";
import { GridApiService } from "./grid-api.service";
import { GridActionsService } from "./grid-actions.service";
import { StatusBarRendererComponent } from "../ag-grid-components/status-bar-renderer/status-bar-renderer.component";
import { LoadingCellRendererComponent } from "../ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { SkuCellRendererComponent } from "../ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { SalesTrendsCellRendererComponent } from "../ag-grid-components/sales-trends-cell-renderer/sales-trends-cell-renderer.component";
import { BooleanFilterComponent } from "../ag-grid-components/boolean-filter/boolean-filter.component";
import { CustomGridHeaderComponent } from "../ag-grid-components/custom-grid-header/custom-grid-header.component";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SalesTrendsGridConfigService implements OnDestroy{
  constructor(
    private gridApiService: GridApiService,
    private GridActionService: GridActionsService
  ) {}
  today = new Date().getTime();
  gridApi: GridApi;
  weekStartDate:Date;
  weekEndDate : Date;
  private destroy$ = new Subject<void>();
  currentYear: number = new Date().getFullYear();
  quartely: any[] = [
    {
      value: "quarter1",
      months: "Jan" + " " + this.currentYear + "-" + "Mar" + " " + this.currentYear,
    },
    {
      value: "quarter2",
      months: "Apr" + " " + this.currentYear + "-" + "Jun" + " " + this.currentYear,
    },
    {
      value: "quarter3",
      months: "Jul" + " " + this.currentYear + "-" + "Sep" + " " + this.currentYear,
    },
    {
      value: "quarter4",
      months: "Oct" + " " + this.currentYear + "-" + "Dec" + " " + this.currentYear,
    },
  ];
  defaultColumns;
  date = new Date();
  selectedWeek: any = [
    {
      label: "This week",
      from: new Date(this.today - this.getDaysAgo(7)),
      to: new Date(this.today),
      checked: true,
    },
    {
      label: "Last week",
      from: new Date(this.today - this.getDaysAgo(14)),
      to: new Date(this.today),
      checked: true,
    },
    {
      label: "2 weeks ago",
      from: new Date(this.today - this.getDaysAgo(21)),
      to: new Date(this.today),
      checked: true,
    },
    {
      label: "3 weeks ago",
      from: new Date(this.today - this.getDaysAgo(28)),
      to: new Date(this.today),
      checked: true,
    },
    {
      label: "4 weeks ago",
      from: new Date(this.today - this.getDaysAgo(35)),
      to: new Date(this.today),
      checked: true,
    },
  ];
  allSelectedDate: any = [];
  selectedType = "weekly";
  commonColumnDefs: any = [
    {
      field: "Active",
      headerTooltip: "Active",
      backendFields: ["Active"],
      filter: "booleanFilterComponent",
      hide: true,
      required:true,
      valueFormatter: (param) => (param.value ? "Yes" : "No"),
      width: 150,
      minWidth:120
    },
    {
      headerName: "Sku",
      field: "Sku",
      backendFields: ["Sku", "Asin", "ImageUrl", "Title","AccountSkuId"],
      sortable: true,
      width: 350,
      minWidth: 350,
      headerClass: "border-right",
      cellClass: "border-right",
      cellRenderer: "skuCellRendererComponent",
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "SKU",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ASIN",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Description",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
    },
    {
      headerName: "Marketplace",
      backendFields: ["Channel", "Account"],
      field: "Account",
      sortable: true,
      width: 110,
      minWidth: 100,
      filter: "agTextColumnFilter",
      headerClass: "border-right",
      cellClass: "border-right",
    },
  ];
  sortModel:any[]=[]

  columnDefs: any = [
    {
      headerName: "This week",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G1QtySold",
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          isSumColumns:true,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G1Returns",
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "orange",
    },
    {
      headerName: "Last week",
      field: "Last Week",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G2Sales",
          isSumColumns:true,
          backendFields:["G2Sales","G2SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G2QtySold",
          backendFields:["G2QtySold","G2QtySoldDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "primary-light",
    },
    {
      headerName: "2 weeks ago",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G3Sales",
          isSumColumns:true,
          backendFields:["G3Sales","G3SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G3QtySold",
          backendFields:["G3QtySold","G3QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G3Returns",
          backendFields:["G3Returns","G3ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "purple",
    },
    {
      headerName: "3 weeks ago",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G4Sales",
          isSumColumns:true,
          backendFields:["G4Sales","G4SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
            cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "success-light",
    },
    {
      headerName: "4 weeks ago",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G5Sales",
          isSumColumns:true,
          backendFields:["G5Sales","G5SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G5QtySold",
          backendFields:["G5QtySold","G5QtySoldDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
            cellRendererParams:(params) =>{
            return {
              difference: params.data.G5QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G5Returns",
          backendFields:["G5Returns","G5ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter", 
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G5Profit",
          backendFields:["G5Profit","G5ProfitDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "spray",
    },
  ];

  monthlyColumns: any = [
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G1QtySold",
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G1Returns",
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
            cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "orange",
    },
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G2Sales",
          backendFields:["G2Sales","G2SalesDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G2QtySold",
          backendFields:["G2QtySold","G2QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
         cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "primary-light",
    },
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G3Sales",
          backendFields:["G3Sales","G3SalesDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G3QtySold",
          backendFields:["G3QtySold","G3QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
         cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G3Returns",
          backendFields:["G3Returns","G1ReturnsDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "purple",
    },
    {
      headerName:'',
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G4Sales",
          backendFields:["G4Sales","G4SalesDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "success-light",
    },
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G5Sales",
          backendFields:["G5Sales","G5SalesDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G5QtySold",
          backendFields:["G5QtySold","G5QtySoldDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
              return {
              difference: params.data.G5QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G5Returns",
          isSumColumns:true,
          backendFields:["G5Returns","G5ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
         cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G5Profit",
          backendFields:["G5Profit","G5ProfitDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "spray",
    },
  ];

  quaterlyColumn: any = [
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          isSumColumns:true,
          width: 90,
          minWidth: 100,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G1QtySold",
          isSumColumns:true,
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter", 
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G1Returns",
          isSumColumns:true,
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "orange",
    },
    {
      headerName:
        "Apr" + " " + this.currentYear + "-" + "Jun" + " " + this.currentYear,
      field: "Last Week",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G2Sales",
          backendFields:["G2Sales","G2SalesDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
           cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G2QtySold",
          backendFields:["G2QtySold","G2QtySoldDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "primary-light",
    },
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G3Sales",
          backendFields:["G3Sales","G3SalesDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G3QtySold",
          backendFields:["G3QtySold","G3QtySoldDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G3Returns",
          backendFields:["G3Returns","G3ReturnsDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "purple",
    },
    {
      headerName: "",
      marryChildren: true,
      children: [
        {
          headerName: "Revenue",
          field: "G4Sales",
          backendFields:["G4Sales","G4SalesDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Qty Sold",
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Returns",
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Profit",
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          isSumColumns:true,
          sortable: true,
          width: 90,
          minWidth: 90,
          filter: "agNumberColumnFilter",
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          cellRenderer : "salesTrendsCellRendere",
         cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
      headerClass: "success-light",
    },
  ];

  components = {
    statusBarRendererComponent: StatusBarRendererComponent,
    loadingCellRenderer: LoadingCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
    salesTrendsCellRendere : SalesTrendsCellRendererComponent,
    booleanFilterComponent: BooleanFilterComponent
  }

  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    tooltipShowDelay: 800,
    suppressServerSideInfiniteScroll: false,
    blockLoadDebounceMillis: 1,
    suppressCopyRowsToClipboard: true,
    defaultColDef: {
      resizable: true,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
      tooltipComponent: "customHeaderTooltipComponent",
    },
    components: this.components,
    autoGroupColumnDef:{
      filter:'agGroupColumnFilter',
      headerValueGetter: params => `Sku`,
    },
    statusBar: {
      statusPanels: [
        {
          statusPanel: "statusBarRendererComponent",
          align: "left",
          statusPanelParams: { model: false },
        },
      ],
    },
    rowHeight: 58,
    headerHeight: 50,
    rowSelection: "single",
    rowMultiSelectWithClick: true,
    loadingCellRenderer: "loadingCellRenderer",
    cacheBlockSize: 100,
    pivotPanelShow: "onlyWhenPivoting",
    rowBuffer: 50,
    enableCellChangeFlash: true,
    suppressMenuHide: true,
    icons: {
      menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
      filter:
        '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
    },
    onGridReady: (e) => {
      this.gridApiService.gridApi$.next(e);
      this.gridApi= e.api;
      e.api.sizeColumnsToFit();
      this.setDateFilter(this.allSelectedDate);
    },
    onColumnVisible: (e) => {
      this.GridActionService.columnVisible(e);
    },
    onColumnPinned: () => this.GridActionService.saveColumnState(),
    onColumnMoved: (e) => {
      if (e) {
        e.api.redrawRows();
      }
      this.GridActionService.saveColumnState();
    },
    onSortChanged: (e) => this.setFilterForOrder(e),
  };

  isFirstColumn(cell) {
    return (
      cell.column.colId === cell.column.parent.displayedChildren[0].colId &&
      cell.column.parent.displayedChildren[0].instanceId != 0
    );
  }

  setDateFilter(e: any) {
      this.selectedWeek.forEach((el,i)=>{
        this.calculateWeekDates(i);
        el.to = this.weekStartDate,
        el.from = this.weekEndDate
      })
    if (!e.length) {
      this.allSelectedDate = this.selectedWeek;
    } else this.allSelectedDate = e.allSelectedDate;
    this.selectedType = e.selectd ? e.selectd : this.selectedType;
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  calculateWeekDates(weeksAgo: number) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    this.weekEndDate = new Date(today);
    this.weekEndDate.setDate(today.getDate() - dayOfWeek - (weeksAgo * 7));
    this.weekStartDate = new Date(today);
    this.weekStartDate.setDate(today.getDate() + (6 - dayOfWeek) - (weeksAgo * 7));
  }
  
  setFilterForOrder(e){
    const columnState = { 
      state: [{
        colId:e.columns[0].colId,
        sort:e.columns[0].sort
      }]
    }
    e.api.applyColumnState(columnState);
    e.api.refreshServerSide({ route: [], purge: true });
  }

  onHeaderCallback(e){
    this.sortModel=e;
    this.gridApi.refreshServerSide({ route: [], purge: true });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
